import React from 'react';
import { Skeleton, Col, Row } from 'antd';
import { translate } from '@portal/services/i18n';

const TransactionDetailsSkeleton = () => {
  return (
    <div>
      <>
        <Row>
          <Col>
            <div className="users-transactions-details__table__container__content">
              <h2 className="users-transactions-details__table__container__content__title">
                {translate('COMPONENTS.USERS_TRANSACTIONS.DETAILS.LABELS.TYPE')}
              </h2>
              <Skeleton.Button active />
            </div>
            <div className="users-transactions-details__table__container__content">
              <h2 className="users-transactions-details__table__container__content__title">
                {translate(
                  'COMPONENTS.USERS_TRANSACTIONS.DETAILS.LABELS.CREATED_AT'
                )}
              </h2>
              <Skeleton.Button active />
            </div>
          </Col>
          <Col>
            <div className="users-transactions-details__table__container__content">
              <h2 className="users-transactions-details__table__container__content__title">
                {translate(
                  'COMPONENTS.USERS_TRANSACTIONS.DETAILS.LABELS.AMOUNT'
                )}
              </h2>
              <Skeleton.Button active />
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="users-transactions-details__line" />
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="users-transactions-details__table__container__content">
              <h2 className="users-transactions-details__table__container__content__title">
                {translate(
                  'COMPONENTS.USERS_TRANSACTIONS.DETAILS.LABELS.PAYER.TITLE'
                )}
              </h2>
              <Skeleton.Button active />
              <Skeleton.Button active />
              <Skeleton.Button active />
              <Skeleton.Button active />
            </div>
          </Col>
          <Col>
            <div className="users-transactions-details__table__container__content">
              <h2 className="users-transactions-details__table__container__content__title">
                {translate(
                  'COMPONENTS.USERS_TRANSACTIONS.DETAILS.LABELS.PAYEE.TITLE'
                )}
              </h2>
              <Skeleton.Button active />
              <Skeleton.Button active />
              <Skeleton.Button active />
              <Skeleton.Button active />
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="users-transactions-details__line" />
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="users-transactions-details__table__container__content">
              <h2 className="users-transactions-details__table__container__content__title">
                {translate(
                  'COMPONENTS.USERS_TRANSACTIONS.DETAILS.LABELS.AUTHENTICATION'
                )}
              </h2>
              <Skeleton.Button active />
            </div>
          </Col>
        </Row>
      </>
    </div>
  );
};

export default TransactionDetailsSkeleton;
